import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";

import ConfirmationService from "primevue/confirmationservice";

const app = createApp(App);
app.component("Button", Button);
app.component("Toast", Toast);
app
  .use(PrimeVue)
  .use(ToastService)
  .use(ConfirmationService)
  .use(store)
  .use(router)
  .mount("#app");
